export default class ApiConfig {
  static baseURL = process.env.REACT_APP_SERVER_BASE_URL;
}
